// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsShareAndroidSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 5a3 3 0 0 1-4.95 2.28 1.008 1.008 0 0 1-.136.094l-6.82 3.98a1.012 1.012 0 0 1-.149.071 3.016 3.016 0 0 1 0 1.15c.05.02.1.043.149.071l6.83 3.98c.046.027.09.057.13.09a3 3 0 1 1-.999 1.705 1.004 1.004 0 0 1-.138-.067l-6.83-3.98a1.01 1.01 0 0 1-.136-.095 3 3 0 1 1 0-4.558c.042-.035.087-.066.135-.095l6.82-3.98c.048-.028.098-.052.149-.071A3 3 0 1 1 21 5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsShareAndroidSolid;
